import React from 'react';

export const TVIcon = () => {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H17V11.1227H0V0ZM7.79228 9.80508H9.20718C9.63752 9.80508 9.63752 10.4771 9.20718 10.4771H7.79228C7.36194 10.4771 7.36194 9.80508 7.79228 9.80508ZM3.50302 11.6259H13.0112V12H3.50302V11.6259ZM4.57778 11.1878H11.9359V11.5619H4.57778V11.1878ZM0.717774 0.74099H16.2828V9.15496H0.717774V0.74099Z"
        fill="white"
      />
    </svg>
  );
};
